import React from 'react'

/**
 * 
 * @param {HTMLElement} element 
 * @param {Boolean} disabled 
 */
export const useImperativeScroll = (element, disabled) => {
    React.useEffect(() => {
        if (!element) {
            return
        }

        element.style.overflowY = disabled ? 'hidden' : 'scroll'

        return () => element.style.overflowY = 'scroll'
    }, [disabled])
}